import { useQuery } from '@tanstack/react-query';

import {
  getMinimalRiskObjectById,
  type GetMinimalRiskObjectByIdResponse,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import queryKeys from '../queryKeys';

export default function useRiskObject(
  id: string,
  options?: QueryOptions<GetMinimalRiskObjectByIdResponse>,
) {
  return useQuery({
    queryKey: queryKeys.byId('', id),
    queryFn: () =>
      getMinimalRiskObjectById(
        { path: { risk_object_id: id, risk_object_revision_id: 'latest' } },
        wgApi,
      ),
    ...options,
  });
}
